import {
  PartnershipDetailsPartnershipLevel,
  PartnershipTierLevel,
} from '@urbanx/agx.agencies.client'
import { DropdownOption } from '@urbanx/agx.ui-components2'
export const PartnershipLevelOptions: DropdownOption[] = [
  {
    value: PartnershipTierLevel.Bronze,
    label: 'Bronze',
  },
  {
    value: PartnershipTierLevel.Silver,
    label: 'Silver',
  },
  {
    value: PartnershipTierLevel.Gold,
    label: 'Gold',
  },
  {
    value: PartnershipTierLevel.Platinum,
    label: 'Platinum',
  },
  {
    value: PartnershipTierLevel.XPartner,
    label: 'X',
  },
]

export const PartnershipLevelLabels: Record<
  PartnershipDetailsPartnershipLevel,
  string
> = {
  [PartnershipDetailsPartnershipLevel.Silver]: 'Silver',
  [PartnershipDetailsPartnershipLevel.Gold]: 'Gold',
  [PartnershipDetailsPartnershipLevel.Platinum]: 'Platinum',
  [PartnershipDetailsPartnershipLevel.XPartner]: 'X',
  [PartnershipDetailsPartnershipLevel.Bronze]: 'Bronze',
}
